import posthog from 'posthog-js';

export const EVENTS = {
    LOGIN_COMPLETED: 'login_completed',
    SESSION_STARTED: 'session_started',
    SESSION_ENDED: 'session_ended'
};

export const trackEvent = (eventName, properties = {}) => {
    try {
        posthog.capture(eventName, properties);
    } catch (e) {
        console.warn('[Analytics] Failed to track event:', e);
    }
};

export const identifyUser = (id, email, role, plan, churchId) => {
    try {
        posthog.identify(id, {
            email,
            role,
            plan,
            churchId
        });
    } catch (e) {
        console.warn('[Analytics] Failed to identify user:', e);
    }
};

export const groupOrganization = (churchId, churchName, plan) => {
    try {
        posthog.group('organization', churchId, {
            name: churchName,
            plan
        });
    } catch (e) {
        console.warn('[Analytics] Failed to group organization:', e);
    }
};

export const resetAnalytics = () => {
    try {
        posthog.reset();
    } catch (e) {
        console.warn('[Analytics] Failed to reset:', e);
    }
};
